import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import ContributionItem from './contributionItem'

import { switchOpenedFromProfile } from '../../../store/contributions/contributionsSlice'
import { ContributionType } from '../../../store/contributions/contributionsTypings'
import s from './materialPreview.module.sass'
import { RootState } from '../../../store/rootReducer'

interface Props {
    contributions: ContributionType[]
    contributionsTotal: number
}

const ContributionsList: React.FunctionComponent<Props> = ({ contributions, contributionsTotal }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const isAgeVerified = useSelector((state: RootState) => state.common.isAgeVerified)

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{t('Contributions')}</div>
                    <div className={s['materialsPreview__counter']}>{contributionsTotal}</div>
                </div>
            </div>
            <div className={s['materialsPreview__list']} onClick={() => dispatch(switchOpenedFromProfile('profile'))}>
                {contributions.map((contribution: ContributionType) => (
                    <ContributionItem contribution={contribution} key={contribution.id} isAgeVerified={isAgeVerified} />
                ))}
            </div>
        </div>
    )
}

export default ContributionsList
